import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap'
import './style/style.sass'
import router from './router'

createApp(App).use(router).mount('#app')
